import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { FilterIcon } from '@heroicons/vue/solid';

import { useAuraFilters } from '@/composables/useAuraFilters';
import { SelectOptionsService } from '@/services';
import type {
    SelectOptionsServiceGetUsersResult,
    SelectOptionsServiceGetQueuesResult,
    SelectOptionsServiceGetMediasResult,
} from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraFilters',
  setup(__props, { expose: __expose }) {
  __expose();

/**
 * AURA Filters - Filter panel using UiRightPanel pattern from CallList
 * SRP: Only responsible for filter panel UI and data loading
 * Logic delegated to useAuraFilters composable
 */
const { t } = useI18n();
const {
    filterOpened,
    draftFilters,
    hasActiveFilters,
    activeFilterCount,
    applyFilters,
    clearFilters,
} = useAuraFilters();

// Loading states
const isLoadingUsers = ref(false);
const isLoadingQueues = ref(false);
const isLoadingMedias = ref(false);

// Options data
const users = ref<SelectOptionsServiceGetUsersResult[]>([]);
const queues = ref<SelectOptionsServiceGetQueuesResult[]>([]);
const medias = ref<SelectOptionsServiceGetMediasResult[]>([]);

// Load options on mount
onMounted(async () => {
    await Promise.all([loadUsers(), loadQueues(), loadMedias()]);
});

async function loadUsers() {
    isLoadingUsers.value = true;
    try {
        const response = await SelectOptionsService.getUsers();
        users.value = response.data;
    } catch (error) {
        console.error('Failed to load users:', error);
    } finally {
        isLoadingUsers.value = false;
    }
}

async function loadQueues() {
    isLoadingQueues.value = true;
    try {
        const response = await SelectOptionsService.getQueues();
        queues.value = response.data;
    } catch (error) {
        console.error('Failed to load queues:', error);
    } finally {
        isLoadingQueues.value = false;
    }
}

async function loadMedias() {
    isLoadingMedias.value = true;
    try {
        const response = await SelectOptionsService.getMedias();
        medias.value = response.data;
    } catch (error) {
        console.error('Failed to load medias:', error);
    } finally {
        isLoadingMedias.value = false;
    }
}

const __returned__ = { t, filterOpened, draftFilters, hasActiveFilters, activeFilterCount, applyFilters, clearFilters, isLoadingUsers, isLoadingQueues, isLoadingMedias, users, queues, medias, loadUsers, loadQueues, loadMedias, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})